import React from 'react';
import { Helmet } from 'react-helmet-async';
import { usePageTitle } from '../hooks/usePageTitle';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
}

const SEO: React.FC<SEOProps> = ({ 
  title = 'Keystone Sign Printing',
  description = 'Professional sign and brand printing services in Montgomery County. High-quality banners, signs, decals, displays, and stickers for your business.',
  keywords = 'sign printing, banners, vinyl signs, decals, stickers, displays, Montgomery County, Lansdale PA, custom signs, business signs',
  image = '/logos/logo.svg',
  url = window.location.href,
  type = 'website'
}) => {
  const fullTitle = title === 'Keystone Sign Printing' ? title : `${title} | Keystone Sign Printing`;
  const fullImageUrl = image.startsWith('http') ? image : `${window.location.origin}${image}`;

  // Use custom hook to ensure title updates reliably
  usePageTitle(title || 'Keystone Sign Printing');

  return (
    <Helmet defer={false} prioritizeSeoTags>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph Tags */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:site_name" content="Keystone Sign Printing" />
      
      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />
      
      {/* Additional SEO Tags */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEO;